import React from 'react';

const EmailCard = ({ subject, from, onMarkAsDone, onReopen }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-3 text-left border border-gray-200 group">
      <div className="text-sm font-semibold text-gray-900 mb-1">
        {subject || 'No Subject'}
      </div>
      <div className="text-xs text-gray-500">{from}</div>
      <div className="mt-2 hidden group-hover:flex gap-2">
        {onMarkAsDone && (
          <button
            className="text-xs text-blue-600 hover:underline focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              onMarkAsDone();
            }}
          >
            MARK AS DONE
          </button>
        )}
        {onReopen && (
          <button
            className="text-xs text-green-600 hover:underline focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              onReopen();
            }}
          >
            RE-OPEN
          </button>
        )}
      </div>
    </div>
  );
};

export default EmailCard;
